module.exports = __webpack_public_path__ + "static/media/DSC_0017 (2).123fa82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0017 (2).jpg
// module id = 615
// module chunks = 0